//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class BackendApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:7073";
    }

    account_Create(ca: CreateAccount, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/account/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ca);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_Create(_response);
        });
    }

    protected processAccount_Create(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    account_GetCreateAccountLiability(signal?: AbortSignal): Promise<Liability> {
        let url_ = this.baseUrl + "/api/v1/account/liability";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_GetCreateAccountLiability(_response);
        });
    }

    protected processAccount_GetCreateAccountLiability(response: Response): Promise<Liability> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Liability;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Liability>(null as any);
    }

    account_GetExistingAccountUserNameByExternalUserName(externalUserName: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/account/existing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(externalUserName);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_GetExistingAccountUserNameByExternalUserName(_response);
        });
    }

    protected processAccount_GetExistingAccountUserNameByExternalUserName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    account_GetExistingAccountUserNameByAccountLinkCode(accountLinkCode: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/account/link/existing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountLinkCode);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_GetExistingAccountUserNameByAccountLinkCode(_response);
        });
    }

    protected processAccount_GetExistingAccountUserNameByAccountLinkCode(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    account_GetUserNamesAvailability(userNames: string[], signal?: AbortSignal): Promise<UserNameAvailability[]> {
        let url_ = this.baseUrl + "/api/v1/account/availability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userNames);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_GetUserNamesAvailability(_response);
        });
    }

    protected processAccount_GetUserNamesAvailability(response: Response): Promise<UserNameAvailability[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserNameAvailability[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserNameAvailability[]>(null as any);
    }

    account_CreateUserName(generateUserName: GenerateUserName, signal?: AbortSignal): Promise<GeneratedUserNameAndPostfix> {
        let url_ = this.baseUrl + "/api/v1/account/createusername";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(generateUserName);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_CreateUserName(_response);
        });
    }

    protected processAccount_CreateUserName(response: Response): Promise<GeneratedUserNameAndPostfix> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeneratedUserNameAndPostfix;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GeneratedUserNameAndPostfix>(null as any);
    }

    account_RemoveDiacritics(data?: string | undefined, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/account/removediacritics?";
        if (data === null)
            throw new globalThis.Error("The parameter 'data' cannot be null.");
        else if (data !== undefined)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_RemoveDiacritics(_response);
        });
    }

    protected processAccount_RemoveDiacritics(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    account_CreateLinkCode(signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/account/createlinkcode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_CreateLinkCode(_response);
        });
    }

    protected processAccount_CreateLinkCode(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    account_Link(la: LinkAccount, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/account/link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(la);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_Link(_response);
        });
    }

    protected processAccount_Link(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    account_GetAssuranceDataIndicatesUnique(linkedIdAssuranceData?: string[] | null | undefined, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/unique?";
        if (linkedIdAssuranceData !== undefined && linkedIdAssuranceData !== null)
            linkedIdAssuranceData && linkedIdAssuranceData.forEach(item => { url_ += "linkedIdAssuranceData=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_GetAssuranceDataIndicatesUnique(_response);
        });
    }

    protected processAccount_GetAssuranceDataIndicatesUnique(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    account_GetCurrentAssuranceLevel(eciuUserName?: string | undefined, signal?: AbortSignal): Promise<AssuranceLevel> {
        let url_ = this.baseUrl + "/api/v1/account/currentassurancelevel?";
        if (eciuUserName === null)
            throw new globalThis.Error("The parameter 'eciuUserName' cannot be null.");
        else if (eciuUserName !== undefined)
            url_ += "eciuUserName=" + encodeURIComponent("" + eciuUserName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_GetCurrentAssuranceLevel(_response);
        });
    }

    protected processAccount_GetCurrentAssuranceLevel(response: Response): Promise<AssuranceLevel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssuranceLevel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssuranceLevel>(null as any);
    }

    account_GetCalculatedAssuranceLevel(getCalculatedAssuranceLevel: GetCalculatedAssuranceLevel, signal?: AbortSignal): Promise<AssuranceLevel> {
        let url_ = this.baseUrl + "/api/v1/account/calculatedassurancelevel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getCalculatedAssuranceLevel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_GetCalculatedAssuranceLevel(_response);
        });
    }

    protected processAccount_GetCalculatedAssuranceLevel(response: Response): Promise<AssuranceLevel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssuranceLevel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssuranceLevel>(null as any);
    }

    account_CreateAndSendEmailVerificationCode(emailAddress?: string | undefined, forceSend?: boolean | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/account/verifyemail?";
        if (emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (forceSend === null)
            throw new globalThis.Error("The parameter 'forceSend' cannot be null.");
        else if (forceSend !== undefined)
            url_ += "forceSend=" + encodeURIComponent("" + forceSend) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_CreateAndSendEmailVerificationCode(_response);
        });
    }

    protected processAccount_CreateAndSendEmailVerificationCode(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    account_VerifyEmail(code: string, emailAddress?: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/account/verifyemail/{code}?";
        if (code === undefined || code === null)
            throw new globalThis.Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        if (emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_VerifyEmail(_response);
        });
    }

    protected processAccount_VerifyEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    account_GetNoReassignLinkedIdsAndRecoveryEmailByUsername(eciuUserName?: string | undefined, signal?: AbortSignal): Promise<UserLinkedIdsAndRecoveryEmailAddress> {
        let url_ = this.baseUrl + "/api/v1/account/resetpassword/linkedids?";
        if (eciuUserName === null)
            throw new globalThis.Error("The parameter 'eciuUserName' cannot be null.");
        else if (eciuUserName !== undefined)
            url_ += "eciuUserName=" + encodeURIComponent("" + eciuUserName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_GetNoReassignLinkedIdsAndRecoveryEmailByUsername(_response);
        });
    }

    protected processAccount_GetNoReassignLinkedIdsAndRecoveryEmailByUsername(response: Response): Promise<UserLinkedIdsAndRecoveryEmailAddress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserLinkedIdsAndRecoveryEmailAddress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserLinkedIdsAndRecoveryEmailAddress>(null as any);
    }

    account_ResetPasswordUsingLinkedId(resetPasswordUsingLinkedId: ResetPasswordUsingLinkedId, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/account/resetpassword/linkedid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resetPasswordUsingLinkedId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_ResetPasswordUsingLinkedId(_response);
        });
    }

    protected processAccount_ResetPasswordUsingLinkedId(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    account_ResetPasswordUsingAccountLinkCode(resetPasswordUsingAccountLinkCode: ResetPasswordUsingAccountLinkCode, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/account/resetpassword/linkcode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resetPasswordUsingAccountLinkCode);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_ResetPasswordUsingAccountLinkCode(_response);
        });
    }

    protected processAccount_ResetPasswordUsingAccountLinkCode(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    account_SendPasswordResetCodeToRecoveryEmailAddress(eciuUserName?: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/account/resetpassword/sendresetpasswordemail?";
        if (eciuUserName === null)
            throw new globalThis.Error("The parameter 'eciuUserName' cannot be null.");
        else if (eciuUserName !== undefined)
            url_ += "eciuUserName=" + encodeURIComponent("" + eciuUserName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_SendPasswordResetCodeToRecoveryEmailAddress(_response);
        });
    }

    protected processAccount_SendPasswordResetCodeToRecoveryEmailAddress(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    account_ValidatePasswordResetCode(passwordResetCode?: string | undefined, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/resetpassword/validate?";
        if (passwordResetCode === null)
            throw new globalThis.Error("The parameter 'passwordResetCode' cannot be null.");
        else if (passwordResetCode !== undefined)
            url_ += "passwordResetCode=" + encodeURIComponent("" + passwordResetCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_ValidatePasswordResetCode(_response);
        });
    }

    protected processAccount_ValidatePasswordResetCode(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    account_ResetPasswordUsingCode(resetPasswordUsingCode: ResetPasswordUsingCode, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/account/resetpassword/code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resetPasswordUsingCode);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_ResetPasswordUsingCode(_response);
        });
    }

    protected processAccount_ResetPasswordUsingCode(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    admin_DataverseSync(forceIncludeOptionSets?: boolean | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/admin/dataversesync?";
        if (forceIncludeOptionSets === null)
            throw new globalThis.Error("The parameter 'forceIncludeOptionSets' cannot be null.");
        else if (forceIncludeOptionSets !== undefined)
            url_ += "forceIncludeOptionSets=" + encodeURIComponent("" + forceIncludeOptionSets) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_DataverseSync(_response);
        });
    }

    protected processAdmin_DataverseSync(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    admin_AzureMonitorSync(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/admin/azuremonitorsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_AzureMonitorSync(_response);
        });
    }

    protected processAdmin_AzureMonitorSync(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    admin_TeamsSync(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/admin/teamssync";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_TeamsSync(_response);
        });
    }

    protected processAdmin_TeamsSync(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    admin_UploadCredentialFile(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/admin/generatemicrocredentials";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmin_UploadCredentialFile(_response);
        });
    }

    protected processAdmin_UploadCredentialFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    admission_CreateAdmission(createAdmission: CreateAdmission, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/admissions/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createAdmission);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmission_CreateAdmission(_response);
        });
    }

    protected processAdmission_CreateAdmission(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    admission_QuickCreate(createAdmission: QuickCreateAdmission, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/admissions/quickcreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createAdmission);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmission_QuickCreate(_response);
        });
    }

    protected processAdmission_QuickCreate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    admission_AcceptAdmission(admissionId: string, admissionAdditionalInformation: AdmissionAdditionalInformation[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/admissions/acceptadmission/{admissionId}";
        if (admissionId === undefined || admissionId === null)
            throw new globalThis.Error("The parameter 'admissionId' must be defined.");
        url_ = url_.replace("{admissionId}", encodeURIComponent("" + admissionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(admissionAdditionalInformation);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmission_AcceptAdmission(_response);
        });
    }

    protected processAdmission_AcceptAdmission(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    admission_RejectAdmission(admissionId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/admissions/rejectadmission/{admissionId}";
        if (admissionId === undefined || admissionId === null)
            throw new globalThis.Error("The parameter 'admissionId' must be defined.");
        url_ = url_.replace("{admissionId}", encodeURIComponent("" + admissionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmission_RejectAdmission(_response);
        });
    }

    protected processAdmission_RejectAdmission(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    admission_GetFiles(admissionId: string, signal?: AbortSignal): Promise<File[]> {
        let url_ = this.baseUrl + "/api/v1/admissions/files/{admissionId}";
        if (admissionId === undefined || admissionId === null)
            throw new globalThis.Error("The parameter 'admissionId' must be defined.");
        url_ = url_.replace("{admissionId}", encodeURIComponent("" + admissionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmission_GetFiles(_response);
        });
    }

    protected processAdmission_GetFiles(response: Response): Promise<File[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as File[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<File[]>(null as any);
    }

    admission_GetRequiredAdditionalInformationForAdmission(admissionId: string, signal?: AbortSignal): Promise<AdmissionAdditionalInformation[]> {
        let url_ = this.baseUrl + "/api/v1/admissions/requiredinformation/{admissionId}";
        if (admissionId === undefined || admissionId === null)
            throw new globalThis.Error("The parameter 'admissionId' must be defined.");
        url_ = url_.replace("{admissionId}", encodeURIComponent("" + admissionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmission_GetRequiredAdditionalInformationForAdmission(_response);
        });
    }

    protected processAdmission_GetRequiredAdditionalInformationForAdmission(response: Response): Promise<AdmissionAdditionalInformation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdmissionAdditionalInformation[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdmissionAdditionalInformation[]>(null as any);
    }

    admission_DownloadFile(admissionId: string, fileName?: string | undefined, signal?: AbortSignal): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/admissions/file/{admissionId}?";
        if (admissionId === undefined || admissionId === null)
            throw new globalThis.Error("The parameter 'admissionId' must be defined.");
        url_ = url_.replace("{admissionId}", encodeURIComponent("" + admissionId));
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmission_DownloadFile(_response);
        });
    }

    protected processAdmission_DownloadFile(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    competence_GetTopicById(competenceId: string, signal?: AbortSignal): Promise<Competence> {
        let url_ = this.baseUrl + "/api/v1/competences/{competenceId}";
        if (competenceId === undefined || competenceId === null)
            throw new globalThis.Error("The parameter 'competenceId' must be defined.");
        url_ = url_.replace("{competenceId}", encodeURIComponent("" + competenceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCompetence_GetTopicById(_response);
        });
    }

    protected processCompetence_GetTopicById(response: Response): Promise<Competence> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Competence;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Competence>(null as any);
    }

    competence_GetAll(signal?: AbortSignal): Promise<CompetenceBase[]> {
        let url_ = this.baseUrl + "/api/v1/competences/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCompetence_GetAll(_response);
        });
    }

    protected processCompetence_GetAll(response: Response): Promise<CompetenceBase[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompetenceBase[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetenceBase[]>(null as any);
    }

    competence_GetAllInUseByLearningOpportunities(signal?: AbortSignal): Promise<CompetenceBase[]> {
        let url_ = this.baseUrl + "/api/v1/competences/allinuse";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCompetence_GetAllInUseByLearningOpportunities(_response);
        });
    }

    protected processCompetence_GetAllInUseByLearningOpportunities(response: Response): Promise<CompetenceBase[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompetenceBase[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetenceBase[]>(null as any);
    }

    competence_GetTree(signal?: AbortSignal): Promise<CompetenceBaseTree> {
        let url_ = this.baseUrl + "/api/v1/competences/tree";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCompetence_GetTree(_response);
        });
    }

    protected processCompetence_GetTree(response: Response): Promise<CompetenceBaseTree> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompetenceBaseTree;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetenceBaseTree>(null as any);
    }

    competence_GetAllSkills(signal?: AbortSignal): Promise<Skill[]> {
        let url_ = this.baseUrl + "/api/v1/competences/skills";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCompetence_GetAllSkills(_response);
        });
    }

    protected processCompetence_GetAllSkills(response: Response): Promise<Skill[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Skill[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Skill[]>(null as any);
    }

    freja_RemoveFrejaConnection(signal?: AbortSignal): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/freja";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFreja_RemoveFrejaConnection(_response);
        });
    }

    protected processFreja_RemoveFrejaConnection(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    freja_Auth(request: FrejaeIDAuthRequest, signal?: AbortSignal): Promise<FrejaeIDAuthResponse> {
        let url_ = this.baseUrl + "/api/v1/freja/auth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFreja_Auth(_response);
        });
    }

    protected processFreja_Auth(response: Response): Promise<FrejaeIDAuthResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FrejaeIDAuthResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FrejaeIDAuthResponse>(null as any);
    }

    freja_InitiateConnection(request: FrejaeIDAuthRequest, signal?: AbortSignal): Promise<FrejaeIDAuthResponse> {
        let url_ = this.baseUrl + "/api/v1/freja/initiate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFreja_InitiateConnection(_response);
        });
    }

    protected processFreja_InitiateConnection(response: Response): Promise<FrejaeIDAuthResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FrejaeIDAuthResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FrejaeIDAuthResponse>(null as any);
    }

    freja_GetStatus(authRef: string, signal?: AbortSignal): Promise<FrejaeIDStatusResponse> {
        let url_ = this.baseUrl + "/api/v1/freja/status/{authRef}";
        if (authRef === undefined || authRef === null)
            throw new globalThis.Error("The parameter 'authRef' must be defined.");
        url_ = url_.replace("{authRef}", encodeURIComponent("" + authRef));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFreja_GetStatus(_response);
        });
    }

    protected processFreja_GetStatus(response: Response): Promise<FrejaeIDStatusResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FrejaeIDStatusResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FrejaeIDStatusResponse>(null as any);
    }

    freja_Collect(request: FrejaeIDCollectRequest, signal?: AbortSignal): Promise<FrejaeIDCollectResponse> {
        let url_ = this.baseUrl + "/api/v1/freja/collect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFreja_Collect(_response);
        });
    }

    protected processFreja_Collect(response: Response): Promise<FrejaeIDCollectResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FrejaeIDCollectResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FrejaeIDCollectResponse>(null as any);
    }

    freja_GenerateQR(request: FrejaeIDRequest, signal?: AbortSignal): Promise<FrejaeIDQRResponse> {
        let url_ = this.baseUrl + "/api/v1/freja/qr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFreja_GenerateQR(_response);
        });
    }

    protected processFreja_GenerateQR(response: Response): Promise<FrejaeIDQRResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FrejaeIDQRResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FrejaeIDQRResponse>(null as any);
    }

    freja_Link(request: FrejaLinkRequest, signal?: AbortSignal): Promise<FrejaLinkResponse> {
        let url_ = this.baseUrl + "/api/v1/freja/link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFreja_Link(_response);
        });
    }

    protected processFreja_Link(response: Response): Promise<FrejaLinkResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FrejaLinkResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FrejaLinkResponse>(null as any);
    }

    invitation_GetInvite(inviteId: string, signal?: AbortSignal): Promise<Invitation> {
        let url_ = this.baseUrl + "/api/v1/invite/{inviteId}";
        if (inviteId === undefined || inviteId === null)
            throw new globalThis.Error("The parameter 'inviteId' must be defined.");
        url_ = url_.replace("{inviteId}", encodeURIComponent("" + inviteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInvitation_GetInvite(_response);
        });
    }

    protected processInvitation_GetInvite(response: Response): Promise<Invitation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Invitation;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Invitation>(null as any);
    }

    invitation_AcceptInvitation(acceptInvitation: AcceptInvitation, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/invite/accept";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(acceptInvitation);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInvitation_AcceptInvitation(_response);
        });
    }

    protected processInvitation_AcceptInvitation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    learningOpportunity_GetById(learningOpportunityId: string, signal?: AbortSignal): Promise<LearningOpportunity> {
        let url_ = this.baseUrl + "/api/v1/learningopportunities/{learningOpportunityId}";
        if (learningOpportunityId === undefined || learningOpportunityId === null)
            throw new globalThis.Error("The parameter 'learningOpportunityId' must be defined.");
        url_ = url_.replace("{learningOpportunityId}", encodeURIComponent("" + learningOpportunityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLearningOpportunity_GetById(_response);
        });
    }

    protected processLearningOpportunity_GetById(response: Response): Promise<LearningOpportunity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LearningOpportunity;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LearningOpportunity>(null as any);
    }

    learningOpportunity_GetByIdLight(learningOpportunityId: string, signal?: AbortSignal): Promise<LearningOpportunityLight> {
        let url_ = this.baseUrl + "/api/v1/learningopportunities/{learningOpportunityId}/light";
        if (learningOpportunityId === undefined || learningOpportunityId === null)
            throw new globalThis.Error("The parameter 'learningOpportunityId' must be defined.");
        url_ = url_.replace("{learningOpportunityId}", encodeURIComponent("" + learningOpportunityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLearningOpportunity_GetByIdLight(_response);
        });
    }

    protected processLearningOpportunity_GetByIdLight(response: Response): Promise<LearningOpportunityLight> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LearningOpportunityLight;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LearningOpportunityLight>(null as any);
    }

    learningOpportunity_GetMy(signal?: AbortSignal): Promise<LearningOpportunityBaseWithMicroCredentials[]> {
        let url_ = this.baseUrl + "/api/v1/learningopportunities/my";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLearningOpportunity_GetMy(_response);
        });
    }

    protected processLearningOpportunity_GetMy(response: Response): Promise<LearningOpportunityBaseWithMicroCredentials[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LearningOpportunityBaseWithMicroCredentials[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LearningOpportunityBaseWithMicroCredentials[]>(null as any);
    }

    learningOpportunity_GetMyForPassport(signal?: AbortSignal): Promise<PassportLearningOpportunity[]> {
        let url_ = this.baseUrl + "/api/v1/learningopportunities/myforpassport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLearningOpportunity_GetMyForPassport(_response);
        });
    }

    protected processLearningOpportunity_GetMyForPassport(response: Response): Promise<PassportLearningOpportunity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PassportLearningOpportunity[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PassportLearningOpportunity[]>(null as any);
    }

    learningOpportunity_GetMySubscriptions(signal?: AbortSignal): Promise<LearningOpportunitySubscription[]> {
        let url_ = this.baseUrl + "/api/v1/learningopportunities/mysubscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLearningOpportunity_GetMySubscriptions(_response);
        });
    }

    protected processLearningOpportunity_GetMySubscriptions(response: Response): Promise<LearningOpportunitySubscription[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LearningOpportunitySubscription[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LearningOpportunitySubscription[]>(null as any);
    }

    learningOpportunity_CreateSubscription(learningOpportunityId: string, notify?: boolean | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/learningopportunities/{learningOpportunityId}/subscription?";
        if (learningOpportunityId === undefined || learningOpportunityId === null)
            throw new globalThis.Error("The parameter 'learningOpportunityId' must be defined.");
        url_ = url_.replace("{learningOpportunityId}", encodeURIComponent("" + learningOpportunityId));
        if (notify === null)
            throw new globalThis.Error("The parameter 'notify' cannot be null.");
        else if (notify !== undefined)
            url_ += "notify=" + encodeURIComponent("" + notify) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLearningOpportunity_CreateSubscription(_response);
        });
    }

    protected processLearningOpportunity_CreateSubscription(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    learningOpportunity_UpdateSubscription(learningOpportunityId: string, notify?: boolean | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/learningopportunities/{learningOpportunityId}/subscription?";
        if (learningOpportunityId === undefined || learningOpportunityId === null)
            throw new globalThis.Error("The parameter 'learningOpportunityId' must be defined.");
        url_ = url_.replace("{learningOpportunityId}", encodeURIComponent("" + learningOpportunityId));
        if (notify === null)
            throw new globalThis.Error("The parameter 'notify' cannot be null.");
        else if (notify !== undefined)
            url_ += "notify=" + encodeURIComponent("" + notify) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLearningOpportunity_UpdateSubscription(_response);
        });
    }

    protected processLearningOpportunity_UpdateSubscription(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    learningOpportunity_DeleteSubscription(learningOpportunityId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/learningopportunities/{learningOpportunityId}/subscription";
        if (learningOpportunityId === undefined || learningOpportunityId === null)
            throw new globalThis.Error("The parameter 'learningOpportunityId' must be defined.");
        url_ = url_.replace("{learningOpportunityId}", encodeURIComponent("" + learningOpportunityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLearningOpportunity_DeleteSubscription(_response);
        });
    }

    protected processLearningOpportunity_DeleteSubscription(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    learningOpportunity_GetAllOnTopic(topicId: string, learningOpportunityType?: LearningOpportunityType | null | undefined, sortByPublishedDate?: boolean | undefined, signal?: AbortSignal): Promise<LearningOpportunityBase[]> {
        let url_ = this.baseUrl + "/api/v1/learningopportunities/allontopic/{topicId}?";
        if (topicId === undefined || topicId === null)
            throw new globalThis.Error("The parameter 'topicId' must be defined.");
        url_ = url_.replace("{topicId}", encodeURIComponent("" + topicId));
        if (learningOpportunityType !== undefined && learningOpportunityType !== null)
            url_ += "learningOpportunityType=" + encodeURIComponent("" + learningOpportunityType) + "&";
        if (sortByPublishedDate === null)
            throw new globalThis.Error("The parameter 'sortByPublishedDate' cannot be null.");
        else if (sortByPublishedDate !== undefined)
            url_ += "sortByPublishedDate=" + encodeURIComponent("" + sortByPublishedDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLearningOpportunity_GetAllOnTopic(_response);
        });
    }

    protected processLearningOpportunity_GetAllOnTopic(response: Response): Promise<LearningOpportunityBase[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LearningOpportunityBase[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LearningOpportunityBase[]>(null as any);
    }

    learningOpportunity_GetAll(signal?: AbortSignal): Promise<LearningOpportunityBase[]> {
        let url_ = this.baseUrl + "/api/v1/learningopportunities/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLearningOpportunity_GetAll(_response);
        });
    }

    protected processLearningOpportunity_GetAll(response: Response): Promise<LearningOpportunityBase[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LearningOpportunityBase[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LearningOpportunityBase[]>(null as any);
    }

    learningOpportunity_GetAllLight(signal?: AbortSignal): Promise<LightWeightLearningOpportunity[]> {
        let url_ = this.baseUrl + "/api/v1/learningopportunities/all/light";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLearningOpportunity_GetAllLight(_response);
        });
    }

    protected processLearningOpportunity_GetAllLight(response: Response): Promise<LightWeightLearningOpportunity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LightWeightLearningOpportunity[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LightWeightLearningOpportunity[]>(null as any);
    }

    learningOpportunity_Browse(fromDate?: string | null | undefined, toDate?: string | null | undefined, signal?: AbortSignal): Promise<BrowseLearningOpportunity[]> {
        let url_ = this.baseUrl + "/api/v1/learningopportunities/browse?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLearningOpportunity_Browse(_response);
        });
    }

    protected processLearningOpportunity_Browse(response: Response): Promise<BrowseLearningOpportunity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrowseLearningOpportunity[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrowseLearningOpportunity[]>(null as any);
    }

    learningOpportunity_GetRecommendationsByVisitsForTopics(topicId?: string | undefined, signal?: AbortSignal): Promise<LearningOpportunityBase[]> {
        let url_ = this.baseUrl + "/api/v1/learningopportunities/recommendations/visitsfortopic?";
        if (topicId === null)
            throw new globalThis.Error("The parameter 'topicId' cannot be null.");
        else if (topicId !== undefined)
            url_ += "topicId=" + encodeURIComponent("" + topicId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLearningOpportunity_GetRecommendationsByVisitsForTopics(_response);
        });
    }

    protected processLearningOpportunity_GetRecommendationsByVisitsForTopics(response: Response): Promise<LearningOpportunityBase[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LearningOpportunityBase[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LearningOpportunityBase[]>(null as any);
    }

    learningOpportunity_GetRecommendationsGetStartedOnTopic(topicId?: string | undefined, signal?: AbortSignal): Promise<LearningOpportunityBase[]> {
        let url_ = this.baseUrl + "/api/v1/learningopportunities/recommendations/getstartedontopic?";
        if (topicId === null)
            throw new globalThis.Error("The parameter 'topicId' cannot be null.");
        else if (topicId !== undefined)
            url_ += "topicId=" + encodeURIComponent("" + topicId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLearningOpportunity_GetRecommendationsGetStartedOnTopic(_response);
        });
    }

    protected processLearningOpportunity_GetRecommendationsGetStartedOnTopic(response: Response): Promise<LearningOpportunityBase[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LearningOpportunityBase[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LearningOpportunityBase[]>(null as any);
    }

    learningOpportunity_GetStartpagePromoted(signal?: AbortSignal): Promise<LearningOpportunityBase[]> {
        let url_ = this.baseUrl + "/api/v1/learningopportunities/startpagepromoted";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLearningOpportunity_GetStartpagePromoted(_response);
        });
    }

    protected processLearningOpportunity_GetStartpagePromoted(response: Response): Promise<LearningOpportunityBase[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LearningOpportunityBase[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LearningOpportunityBase[]>(null as any);
    }

    learningOpportunity_CheckPrerequisites(learningOpportunityIds?: string[] | undefined, signal?: AbortSignal): Promise<PrerequisiteResultWithEloId[]> {
        let url_ = this.baseUrl + "/api/v1/learningopportunities/prerequisites?";
        if (learningOpportunityIds === null)
            throw new globalThis.Error("The parameter 'learningOpportunityIds' cannot be null.");
        else if (learningOpportunityIds !== undefined)
            learningOpportunityIds && learningOpportunityIds.forEach(item => { url_ += "learningOpportunityIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLearningOpportunity_CheckPrerequisites(_response);
        });
    }

    protected processLearningOpportunity_CheckPrerequisites(response: Response): Promise<PrerequisiteResultWithEloId[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PrerequisiteResultWithEloId[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrerequisiteResultWithEloId[]>(null as any);
    }

    organisation_GetById(organisationId: string, signal?: AbortSignal): Promise<Organisation> {
        let url_ = this.baseUrl + "/api/v1/organisation/{organisationId}";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisation_GetById(_response);
        });
    }

    protected processOrganisation_GetById(response: Response): Promise<Organisation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Organisation;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Organisation>(null as any);
    }

    organisation_GetAll(signal?: AbortSignal): Promise<OrganisationBase[]> {
        let url_ = this.baseUrl + "/api/v1/organisation/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisation_GetAll(_response);
        });
    }

    protected processOrganisation_GetAll(response: Response): Promise<OrganisationBase[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationBase[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganisationBase[]>(null as any);
    }

    organisation_GetCompanyInfo(signal?: AbortSignal): Promise<CompanyInfo[]> {
        let url_ = this.baseUrl + "/api/v1/organisation/companyinfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisation_GetCompanyInfo(_response);
        });
    }

    protected processOrganisation_GetCompanyInfo(response: Response): Promise<CompanyInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyInfo[]>(null as any);
    }

    person_GetPhoto(azureAdUserId: string, signal?: AbortSignal): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/person/{azureAdUserId}/photo";
        if (azureAdUserId === undefined || azureAdUserId === null)
            throw new globalThis.Error("The parameter 'azureAdUserId' must be defined.");
        url_ = url_.replace("{azureAdUserId}", encodeURIComponent("" + azureAdUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPerson_GetPhoto(_response);
        });
    }

    protected processPerson_GetPhoto(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    person_GetOrQuickCreate(quickCreateAccount: QuickCreateAccount, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/person/getorcreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(quickCreateAccount);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPerson_GetOrQuickCreate(_response);
        });
    }

    protected processPerson_GetOrQuickCreate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    person_GetById(personId: string, signal?: AbortSignal): Promise<Person> {
        let url_ = this.baseUrl + "/api/v1/person/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPerson_GetById(_response);
        });
    }

    protected processPerson_GetById(response: Response): Promise<Person> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Person;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Person>(null as any);
    }

    person_GetByAzureAdId(azureAdUserId: string, signal?: AbortSignal): Promise<Person> {
        let url_ = this.baseUrl + "/api/v1/person/getbyazureid/{azureAdUserId}";
        if (azureAdUserId === undefined || azureAdUserId === null)
            throw new globalThis.Error("The parameter 'azureAdUserId' must be defined.");
        url_ = url_.replace("{azureAdUserId}", encodeURIComponent("" + azureAdUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPerson_GetByAzureAdId(_response);
        });
    }

    protected processPerson_GetByAzureAdId(response: Response): Promise<Person> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Person;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Person>(null as any);
    }

    profile_Get(signal?: AbortSignal): Promise<Profile> {
        let url_ = this.baseUrl + "/api/v1/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile_Get(_response);
        });
    }

    protected processProfile_Get(response: Response): Promise<Profile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Profile;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Profile>(null as any);
    }

    profile_GetPhoto(signal?: AbortSignal): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/profile/photo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile_GetPhoto(_response);
        });
    }

    protected processProfile_GetPhoto(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    profile_GetFiles(signal?: AbortSignal): Promise<File[]> {
        let url_ = this.baseUrl + "/api/v1/profile/files";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile_GetFiles(_response);
        });
    }

    protected processProfile_GetFiles(response: Response): Promise<File[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as File[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<File[]>(null as any);
    }

    profile_DownloadFile(fileName?: string | undefined, signal?: AbortSignal): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/profile/file?";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile_DownloadFile(_response);
        });
    }

    protected processProfile_DownloadFile(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    profile_UploadFile(file?: FileParameter | undefined, documentTypeName?: string | undefined, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/profile/file?";
        if (documentTypeName === null)
            throw new globalThis.Error("The parameter 'documentTypeName' cannot be null.");
        else if (documentTypeName !== undefined)
            url_ += "documentTypeName=" + encodeURIComponent("" + documentTypeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile_UploadFile(_response);
        });
    }

    protected processProfile_UploadFile(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    profile_DeleteFile(fileName?: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/profile/file?";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile_DeleteFile(_response);
        });
    }

    protected processProfile_DeleteFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    profile_GetLinkedIds(signal?: AbortSignal): Promise<LinkedId[]> {
        let url_ = this.baseUrl + "/api/v1/profile/linkedIds";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile_GetLinkedIds(_response);
        });
    }

    protected processProfile_GetLinkedIds(response: Response): Promise<LinkedId[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LinkedId[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LinkedId[]>(null as any);
    }

    profile_UpdatePassword(updatePassword: UpdatePassword, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/profile/password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatePassword);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile_UpdatePassword(_response);
        });
    }

    protected processProfile_UpdatePassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    profile_UpdateRecoveryEmailAddress(recoveryEmailAddress?: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/profile/recoveryemail?";
        if (recoveryEmailAddress === null)
            throw new globalThis.Error("The parameter 'recoveryEmailAddress' cannot be null.");
        else if (recoveryEmailAddress !== undefined)
            url_ += "recoveryEmailAddress=" + encodeURIComponent("" + recoveryEmailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile_UpdateRecoveryEmailAddress(_response);
        });
    }

    protected processProfile_UpdateRecoveryEmailAddress(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    profile_UpdateDoNotBulkEmails(doNotBulkEmails?: boolean | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/profile/donotbulkemails?";
        if (doNotBulkEmails === null)
            throw new globalThis.Error("The parameter 'doNotBulkEmails' cannot be null.");
        else if (doNotBulkEmails !== undefined)
            url_ += "doNotBulkEmails=" + encodeURIComponent("" + doNotBulkEmails) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile_UpdateDoNotBulkEmails(_response);
        });
    }

    protected processProfile_UpdateDoNotBulkEmails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    profile_UpdateMotivationScanResult(updateMotivationScanResult: UpdateMotivationScanResult, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/profile/motivationscan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateMotivationScanResult);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile_UpdateMotivationScanResult(_response);
        });
    }

    protected processProfile_UpdateMotivationScanResult(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    profile_UpdatePersonalDetails(updatePersonalDetails: UpdatePersonalDetails, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/profile/personaldetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatePersonalDetails);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile_UpdatePersonalDetails(_response);
        });
    }

    protected processProfile_UpdatePersonalDetails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    profile_UpdateContactInformation(updateContactInformation: UpdateContactInformation, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/profile/contactinformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateContactInformation);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile_UpdateContactInformation(_response);
        });
    }

    protected processProfile_UpdateContactInformation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    profile_UpdateWorkAndStudy(updateWorkAndStudy: UpdateWorkAndStudy, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/profile/workandstudy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateWorkAndStudy);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile_UpdateWorkAndStudy(_response);
        });
    }

    protected processProfile_UpdateWorkAndStudy(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    profile_GetCertificate(learningOpportunityId: string, signal?: AbortSignal): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/profile/certificate/{learningOpportunityId}";
        if (learningOpportunityId === undefined || learningOpportunityId === null)
            throw new globalThis.Error("The parameter 'learningOpportunityId' must be defined.");
        url_ = url_.replace("{learningOpportunityId}", encodeURIComponent("" + learningOpportunityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile_GetCertificate(_response);
        });
    }

    protected processProfile_GetCertificate(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    profile_GetCompetencePassport(signal?: AbortSignal): Promise<CompetencePassport> {
        let url_ = this.baseUrl + "/api/v1/profile/competencepassport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile_GetCompetencePassport(_response);
        });
    }

    protected processProfile_GetCompetencePassport(response: Response): Promise<CompetencePassport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompetencePassport;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetencePassport>(null as any);
    }

    profile_GetMySkills(signal?: AbortSignal): Promise<LearnerSkill[]> {
        let url_ = this.baseUrl + "/api/v1/profile/myskills";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile_GetMySkills(_response);
        });
    }

    protected processProfile_GetMySkills(response: Response): Promise<LearnerSkill[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LearnerSkill[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LearnerSkill[]>(null as any);
    }

    profile_UpdateSkillGoal(updateSkill: UpdateSkillGoal, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/profile/updateskillgoal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateSkill);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile_UpdateSkillGoal(_response);
        });
    }

    protected processProfile_UpdateSkillGoal(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    profile_RequestProfileUpdate(organisationId?: string | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/profile/requestprofileupdate?";
        if (organisationId !== undefined && organisationId !== null)
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile_RequestProfileUpdate(_response);
        });
    }

    protected processProfile_RequestProfileUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    profile_GetOnboardings(signal?: AbortSignal): Promise<ContractOnboarding[]> {
        let url_ = this.baseUrl + "/api/v1/profile/onboarding";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile_GetOnboardings(_response);
        });
    }

    protected processProfile_GetOnboardings(response: Response): Promise<ContractOnboarding[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContractOnboarding[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractOnboarding[]>(null as any);
    }

    support_CreateAuthenticatedSupportRequest(casr: CreateAuthenticatedSupportRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/support/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(casr);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSupport_CreateAuthenticatedSupportRequest(_response);
        });
    }

    protected processSupport_CreateAuthenticatedSupportRequest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    support_CreateUnAuthenticatedSupportRequest(cuasr: CreateUnAuthenticatedSupportRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/support/createnoauth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cuasr);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSupport_CreateUnAuthenticatedSupportRequest(_response);
        });
    }

    protected processSupport_CreateUnAuthenticatedSupportRequest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    support_GetAllContactFormSettings(signal?: AbortSignal): Promise<ContactFormSetting[]> {
        let url_ = this.baseUrl + "/api/v1/support/contactformsettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSupport_GetAllContactFormSettings(_response);
        });
    }

    protected processSupport_GetAllContactFormSettings(response: Response): Promise<ContactFormSetting[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContactFormSetting[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactFormSetting[]>(null as any);
    }

    utility_GetCountryList(signal?: AbortSignal): Promise<KeyValuePairOfGuidAndString[]> {
        let url_ = this.baseUrl + "/api/v1/data/countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUtility_GetCountryList(_response);
        });
    }

    protected processUtility_GetCountryList(response: Response): Promise<KeyValuePairOfGuidAndString[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KeyValuePairOfGuidAndString[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeyValuePairOfGuidAndString[]>(null as any);
    }

    utility_GetLanguageList(signal?: AbortSignal): Promise<KeyValuePairOfGuidAndString[]> {
        let url_ = this.baseUrl + "/api/v1/data/languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUtility_GetLanguageList(_response);
        });
    }

    protected processUtility_GetLanguageList(response: Response): Promise<KeyValuePairOfGuidAndString[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KeyValuePairOfGuidAndString[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeyValuePairOfGuidAndString[]>(null as any);
    }

    utility_GetNationalityList(signal?: AbortSignal): Promise<KeyValuePairOfGuidAndString[]> {
        let url_ = this.baseUrl + "/api/v1/data/nationalities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUtility_GetNationalityList(_response);
        });
    }

    protected processUtility_GetNationalityList(response: Response): Promise<KeyValuePairOfGuidAndString[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KeyValuePairOfGuidAndString[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeyValuePairOfGuidAndString[]>(null as any);
    }

    utility_GetGenderList(signal?: AbortSignal): Promise<KeyValuePairOfIntegerAndString[]> {
        let url_ = this.baseUrl + "/api/v1/data/genders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUtility_GetGenderList(_response);
        });
    }

    protected processUtility_GetGenderList(response: Response): Promise<KeyValuePairOfIntegerAndString[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KeyValuePairOfIntegerAndString[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeyValuePairOfIntegerAndString[]>(null as any);
    }

    utility_GetDegreeList(signal?: AbortSignal): Promise<KeyValuePairOfGuidAndString[]> {
        let url_ = this.baseUrl + "/api/v1/data/degrees";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUtility_GetDegreeList(_response);
        });
    }

    protected processUtility_GetDegreeList(response: Response): Promise<KeyValuePairOfGuidAndString[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KeyValuePairOfGuidAndString[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeyValuePairOfGuidAndString[]>(null as any);
    }

    utility_GetAudienceList(signal?: AbortSignal): Promise<Audience2[]> {
        let url_ = this.baseUrl + "/api/v1/data/audiences";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUtility_GetAudienceList(_response);
        });
    }

    protected processUtility_GetAudienceList(response: Response): Promise<Audience2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Audience2[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Audience2[]>(null as any);
    }
}

export interface CreateAccount {
    eciuUserName: string;
    eciuPassword: string;
    eciuFirstName: string;
    eciuLastName: string;
    eciuCountry: string | null;
    dateOfBirth: string | null;
    azureAdDisplayName: string;
    linkedIdEduPersonPrincipalName: string;
    linkedIdEmailAddress: string;
    linkedIdEuropeanStudentIdentifier: string | null;
    linkedIdFirstName: string;
    linkedIdLastName: string;
    linkedIdMemberUniversityDomainName: string;
    linkedIdAssuranceData: string[] | null;
    acceptCreateAccountTermsAndConditions: boolean;
    mfaLogin: boolean;
    linkedIdEduPersonAffiliation: string[] | null;
    forwardEmailsToLinkedIdEmailAddress: boolean | null;
    recoveryEmailAddress: string | null;
    doNotBulkEmails: boolean;
}

export interface Liability {
    contentUrl: string | null;
    description: string | null;
    displayName: string | null;
    name: string | null;
    version: number | null;
    liabilityType: LiabilityType | null;
}

export interface LiabilityType {
    description: string | null;
    name: string | null;
    isConsent: boolean | null;
}

export interface UserNameAvailability {
    userName: string;
    available: boolean;
}

export interface GeneratedUserNameAndPostfix {
    userName: string;
    postfix: string | null;
}

export interface GenerateUserName {
    eciuFirstName: string;
    eciuLastName: string;
}

export interface LinkAccount {
    accountLinkCode: string;
    linkedIdEduPersonPrincipalName: string;
    linkedIdEmailAddress: string;
    linkedIdEuropeanStudentIdentifier: string | null;
    linkedIdFirstName: string;
    linkedIdLastName: string;
    dateOfBirth: string | null;
    linkedIdMemberUniversityDomainName: string;
    linkedIdAssuranceData: string[] | null;
    mfaLogin: boolean;
    linkedIdEduPersonAffiliation: string[] | null;
}

export interface AssuranceLevel {
    id: string | null;
    name: string | null;
    description: string | null;
    order: number | null;
}

export interface GetCalculatedAssuranceLevel {
    linkedIdAssuranceData: string[] | null;
    mfaLogin: boolean;
}

export interface UserLinkedIdsAndRecoveryEmailAddress {
    linkedIds: LinkedId[];
    recoveryEmailAddress: string | null;
}

export interface LinkedId {
    eduPersonPrincipalName: string | null;
    emailAddress: string | null;
    europeanStudentIdentifier: string | null;
    firstName: string | null;
    lastName: string | null;
    dateOfBirth: string | null;
    homeOrganisation: OrganisationBase | null;
    latestAssuranceLevel: AssuranceLevel | null;
    isVerified: boolean;
}

export interface OrganisationBase {
    id: string;
    name: string | null;
    description: string | null;
    logoTypeImagesPath: string | null;
    backgroundImagesPath: string | null;
    eciuMemberUniversity: boolean;
    location: string | null;
    url: string | null;
    eciuMemberUniversityDomainName: string | null;
}

export interface ResetPasswordUsingLinkedId {
    newPassword: string;
    linkedIdEduPersonPrincipalName: string;
    acceptCreateAccountTermsAndConditions: boolean;
    linkedIdAssuranceData: string[] | null;
    mfaLogin: boolean;
}

export interface ResetPasswordUsingAccountLinkCode {
    accountLinkCode: string;
    newPassword: string;
    acceptCreateAccountTermsAndConditions: boolean;
    linkedIdAssuranceData: string[] | null;
    mfaLogin: boolean;
}

export interface ResetPasswordUsingCode {
    resetPasswordCode: string;
    newPassword: string;
    acceptCreateAccountTermsAndConditions: boolean;
}

export interface CreateAdmission {
    learningOpportunityId: string;
    fileNames: string[];
    additionalInformation: string | null;
    willAttendHybrid: boolean | null;
    wantsMobilityFunding: boolean | null;
}

export interface QuickCreateAdmission {
    personId: string;
    email: string;
    learningOpportunityId: string;
}

export interface AdmissionAdditionalInformation {
    name: string | null;
    canBeEdited: boolean | null;
    value: string | null;
    type: string | null;
    list: KeyValuePairOfStringAndString[] | null;
}

export interface KeyValuePairOfStringAndString {
    key: string | null;
    value: string | null;
}

export interface File {
    displayName: string;
    name: string;
    createdDate: string | null;
    documentTypeName: string;
}

export interface CompetenceBase {
    id: string;
    name: string | null;
    description: string | null;
    shortDescription: string | null;
    subTitle: string | null;
    imagesPath: string | null;
    imageAltText: string | null;
    skills: Skill[] | null;
    hideFromMotivationScan: boolean | null;
    showInBrowseBanner: boolean | null;
    showAsFilterTopic: boolean | null;
    sortOrderInMotivationScan: number | null;
    sortOrderInBrowseBanner: number | null;
    sortOrderInFilterTopic: number | null;
}

export interface Competence extends CompetenceBase {
    challengeCount: number;
    microModuleCount: number;
    subTopics: CompetenceBase[] | null;
}

export interface Skill {
    id: string;
    name: string | null;
    description: string | null;
    uri: string | null;
    url: string | null;
    taxonomyId: string | null;
    taxonomyName: string | null;
}

export interface CompetenceBaseTree {
    rootCompetences: CompetenceBaseWithChildren[];
}

export interface CompetenceBaseWithChildren extends CompetenceBase {
    children: CompetenceBaseWithChildren[];
}

export interface FrejaeIDAuthResponse {
    authRef: string;
}

export interface FrejaeIDAuthRequest {
    callbackUrl: string | null;
}

export interface FrejaeIDStatusResponse {
    status: FrejaAuthStatus;
}

export enum FrejaAuthStatus {
    Started = 0,
    DeliveredToMobile = 1,
    Success = 2,
    Fail = 3,
}

export interface FrejaeIDCollectResponse {
    authRef: string;
    status: FrejaeIDTransactionStatus;
    details: string | null;
    users: FrejaUserData[] | null;
    completionData: FrejaeIDCompletionData | null;
    qrData: string;
    transactionReference: string;
}

export enum FrejaeIDTransactionStatus {
    STARTED = 0,
    DELIVERED_TO_MOBILE = 1,
    CANCELED = 2,
    RP_CANCELED = 3,
    EXPIRED = 4,
    APPROVED = 5,
    REJECTED = 6,
}

export interface FrejaUserData {
    norEduPersonLIN: string;
    norEduPersonNIN: string;
    firstName: string;
    lastName: string;
    displayText: string;
}

export interface FrejaeIDCompletionData {
    name: string | null;
    surname: string | null;
    ssn: string | null;
    ssnCountry: string | null;
    dateOfBirth: string;
    uniquePersonalIdentifier: string;
}

export interface FrejaeIDCollectRequest {
    authRef: string;
}

export interface FrejaeIDQRResponse {
    qrData: string;
}

export interface FrejaeIDRequest {
    authRef: string;
}

export interface FrejaLinkResponse {
    status: FrejaLinkStatus;
}

export enum FrejaLinkStatus {
    Success = 0,
    Fail = 1,
}

export interface FrejaLinkRequest {
    authRef: string | null;
}

export interface Invitation {
    id: string;
    emailAddress: string | null;
    firstName: string | null;
    lastName: string | null;
    sentDate: string | null;
    expirationDate: string | null;
    contractId: string | null;
    statusReasonId: number | null;
    existingPersonEmail: string | null;
    organisationName: string | null;
    userCanModifyName: boolean;
}

export interface AcceptInvitation {
    invitationId: string;
    eciuUserName: string;
    eciuPassword: string;
    eciuFirstName: string;
    eciuLastName: string;
    eciuCountry: string;
    azureAdDisplayName: string;
    linkedIdEmailAddress: string;
    linkedIdFirstName: string;
    linkedIdLastName: string;
    acceptCreateAccountTermsAndConditions: boolean;
    forwardEmailsToLinkedIdEmailAddress: boolean | null;
    recoveryEmailAddress: string;
    doNotBulkEmails: boolean;
}

export interface LearningOpportunityBase {
    id: string;
    admissionInformation: string | null;
    admissionProcessInformation: string | null;
    applicationPeriodEndDate: string | null;
    applicationPeriodStartDate: string | null;
    topics: LearningOpportunityTopic[] | null;
    topicsWithLevel: TopicAndLevel[];
    complexity: Complexity | null;
    description: string | null;
    eciulmsEnabled: boolean | null;
    ects: number | null;
    educationId: string | null;
    endDate: string | null;
    hostingUniversity: OrganisationBase | null;
    imagesPath: string | null;
    imageAltText: string | null;
    introduction: string | null;
    lmsUrl: string | null;
    name: string | null;
    pace: number | null;
    participantInformation: string | null;
    publishedDate: string | null;
    publishResult: string | null;
    scope: Scope | null;
    credentialType: CredentialType | null;
    simplifiedAdmissionProcess: boolean | null;
    enableQuickCreate: boolean | null;
    enablePrerequisites: boolean | null;
    startDate: string | null;
    studyFormat: StudyFormat | null;
    selfPaced: boolean | null;
    subTitle: string | null;
    syllabus: string | null;
    type: LearningOpportunityType | null;
    status: LearningOpportunityStatus | null;
    userData: LearningOpportunityUserData | null;
    startPagePromotionPriority: number | null;
    numberOfVisits: number | null;
    documentTypes: DocumentType[] | null;
    tags: Tag[];
    teamsAccessDate: string | null;
    volumeOfLearning: number | null;
    hideFromEngage: boolean | null;
    maximumNumberOfSeats: number | null;
    numberOfSeatsOccupied: number | null;
}

export interface LearningOpportunity extends LearningOpportunityBase {
    teamchers: LearningOpportunityPerson[];
    learners: LearningOpportunityLearner[];
    challengeProviderOrganisations: OrganisationBase[];
    associatedPartnerOrganisations: OrganisationBase[];
    usesSimplifiedAdmissionProcessAndAdmissionIsFull: boolean;
    maximumNumberOfSeats: number | null;
    numberOfSeatsOccupied: number;
    learningOutcomes: LearningOutcome[] | null;
    learningActivities: LearningActivity[] | null;
    generateDigitalCredentials: boolean;
    eqfLevelAlternateName: string | null;
    audiences: Audience[] | null;
}

export interface LearningOpportunityPerson {
    firstName: string | null;
    lastName: string | null;
    emailAddress: string | null;
    azureAdUserId: string | null;
}

export interface LearningOpportunityLearner {
    firstName: string | null;
    lastName: string | null;
    emailAddress: string | null;
    azureAdUserId: string | null;
    learningOpportunityUserStatus: LearningOpportunityUserStatus | null;
}

export enum LearningOpportunityUserStatus {
    LearnerApplied = 0,
    LearnerAttending = 1,
    LearnerCompleted = 2,
    AdmissionOfficerDeniedApplication = 3,
    OfferToLearnerExpired = 4,
    OfferedToLearner = 5,
    LearnerRejectedOffer = 6,
    LearnerFailed = 7,
    LearnerDroppedOut = 8,
}

export interface LearningOutcome {
    id: string;
    name: string | null;
    description: string | null;
    competenceAndLevels: CompetenceAndLevel[] | null;
}

export interface CompetenceAndLevel {
    competenceId: string | null;
    competenceName: string | null;
    level: Level | null;
    skills: Skill[] | null;
}

export enum Level {
    LevelAExplorer = 623140000,
    LevelBExpert = 623140001,
    LevelCPioneer = 623140002,
}

export interface LearningActivity {
    id: string;
    name: string | null;
    description: string | null;
    modeOfLearning: string | null;
    type: string | null;
}

export interface Audience {
    id: string | null;
    name: string | null;
    description: string | null;
    url: string | null;
    hideFromFilter: boolean | null;
}

export interface LearningOpportunityTopic {
    id: string;
    name: string | null;
}

export interface TopicAndLevel {
    topicId: string;
    levelId: number | null;
}

export enum Complexity {
    _1 = 623140000,
    _2 = 623140001,
    _3 = 623140002,
    _4 = 623140003,
    _5 = 623140004,
    _6 = 623140005,
    _7 = 623140006,
}

export enum Scope {
    Nano = 623140000,
    Mini = 623140001,
    Standard = 623140002,
    Strategic = 623140003,
}

export enum CredentialType {
    DigitalCredential = 623140000,
    PDFCertificate = 623140001,
}

export enum StudyFormat {
    Campus = 623140000,
    Hybrid = 623140001,
    Online = 623140002,
    Blended = 623140003,
}

export enum LearningOpportunityType {
    Challenge = 623140000,
    MicroModule = 623140001,
}

export enum LearningOpportunityStatus {
    ComingSoon = 0,
    OpenForApplication = 1,
    ClosedForApplication = 2,
    Finished = 3,
    Unknown = 4,
}

export interface LearningOpportunityUserData {
    admission: AdmissionBase | null;
    status: LearningOpportunityUserStatus | null;
    mobilityStatusReason: MobilityStatusReason | null;
    grade: Grade | null;
    gradingScheme: GradingScheme | null;
    canApplyForMobilityFunding: boolean;
}

export interface AdmissionBase {
    id: string | null;
    name: string | null;
    createdDate: string | null;
    offeredDate: string | null;
    offerResponseDate: string | null;
    offerDueDate: string | null;
    deniedDate: string | null;
    additionalInformation: string | null;
}

export enum MobilityStatusReason {
    New = 1,
    Finished = 2,
    InProcess = 623140001,
    Decided = 623140002,
    Aborted = 623140003,
    Declined = 623140004,
    NotApplicable = 623140005,
    VirtualMobility = 623140006,
}

export interface Grade {
    value: string | null;
    description: string | null;
    gradingOrder: number | null;
    gradingSchemeId: string | null;
}

export interface GradingScheme {
    name: string | null;
    description: string | null;
}

export interface DocumentType {
    id: string | null;
    name: string | null;
    description: string | null;
}

export interface Tag {
    id: string;
    name: string | null;
}

export interface LearningOpportunityLight {
    id: string;
    name: string;
    quickCreateEnabled: boolean;
}

export interface LearningOpportunityBaseWithMicroCredentials extends LearningOpportunityBase {
    userData: LearningOpportunityUserDataWithMicroCredentials | null;
    generateMicroCredentials: boolean;
    generateDigitalCredentials: boolean;
}

export interface LearningOpportunityUserDataWithMicroCredentials extends LearningOpportunityUserData {
    microCredentialAvailable: boolean;
    learnerCompletedButNoLinkedIdToLOHostingUniversityAndTooLowAssuranceLevel: boolean;
}

export interface PassportLearningOpportunity {
    id: string;
    startDate: string | null;
    endDate: string | null;
    title: string | null;
    status: LearningOpportunityStatus | null;
    type: LearningOpportunityType | null;
    hostingUniversityId: string | null;
    hostingUniversity: OrganisationBase | null;
    hostingUniversityName: string | null;
    ects: number | null;
    topics: LearningOpportunityTopic[] | null;
    maximumNumberOfSeats: number | null;
    numberOfSeatsOccupied: number | null;
    applicationEndDate: string | null;
    imagesPath: string | null;
    userStatus: LearningOpportunityUserStatus | null;
    userData: LearningOpportunityUserDataWithMicroCredentials | null;
    generateMicroCredentials: boolean;
    generateDigitalCredentials: boolean;
}

export interface LearningOpportunitySubscription {
    id: string;
    learningOpportunity: LearningOpportunityBase;
    notify: boolean | null;
}

export interface LightWeightLearningOpportunity {
    id: string | null;
    imagesPath: string | null;
    title: string | null;
    startDate: string | null;
    endDate: string | null;
    type: LearningOpportunityType | null;
    userData: LearningOpportunityUserData | null;
    status: LearningOpportunityStatus | null;
    userStatus: LearningOpportunityUserStatus | null;
    maximumNumberOfSeats: number | null;
    numberOfSeatsOccupied: number | null;
    applicationEndDate: string | null;
    topics: LearningOpportunityTopic[] | null;
}

export interface BrowseLearningOpportunity {
    id: string;
    startDate: string | null;
    endDate: string | null;
    audienceIds: string[] | null;
    tags: Tag[] | null;
    title: string | null;
    status: LearningOpportunityStatus | null;
    selfPaced: boolean | null;
    type: LearningOpportunityType | null;
    studyFormat: StudyFormat | null;
    topicsWithLevel: TopicAndLevel[] | null;
    hostingUniversityId: string | null;
    hostingUniversity: OrganisationBase | null;
    ects: number | null;
    volumeOfLearning: number | null;
    topics: LearningOpportunityTopic[] | null;
    publishedDate: string | null;
    maximumNumberOfSeats: number | null;
    numberOfSeatsOccupied: number | null;
    applicationEndDate: string | null;
    imagesPath: string | null;
    userStatus: LearningOpportunityUserStatus | null;
}

export interface PrerequisiteResultWithEloId {
    id: string;
    prerequisiteResult: PrerequisiteResult[] | null;
}

export interface PrerequisiteResult {
    isPrerequisiteMet: boolean;
    isPrerequisiteMandatory: boolean;
    reasonForFailure: string | null;
    moreInformation: string[];
}

export interface Organisation extends OrganisationBase {
    learningOpportunitiesAsHost: LearningOpportunityBase[];
    learningOpportunitiesAsPartner: LearningOpportunityBase[];
}

export interface CompanyInfo {
    companyName: string | null;
    onboardings: ContractOnboarding[] | null;
    employees: KeyValuePairOfGuidAndListOfEmployee[] | null;
}

export interface ContractOnboarding {
    contractId: string;
    contractName: string | null;
    onboardingImagePath: string | null;
    onboardingIntroduction: string | null;
    onboardingNextStep: string | null;
    onboardingUrl: string | null;
    contractStartDate: string | null;
    contractEndDate: string | null;
    organisationName: string | null;
    organisationLogoPath: string | null;
    goals: CompanyGoal[] | null;
    learningOpportunities: LightWeightLearningOpportunity[] | null;
}

export interface CompanyGoal {
    skillName: string;
    skillDescription: string;
    skillId: string;
    skillUrl: string;
    level: Level;
    isCompleted: boolean;
}

export interface KeyValuePairOfGuidAndListOfEmployee {
    key: string;
    value: Employee[] | null;
}

export interface Employee {
    hasAcceptedInvite: boolean;
    emailAddress: string;
    fullName: string;
}

export interface QuickCreateAccount {
    email: string;
    firstName: string;
    lastName: string;
}

export interface Person {
    id: string;
    firstName: string | null;
    lastName: string | null;
    description: string | null;
    learningOpportunititesAsTeamcher: LearningOpportunityBase[];
}

export interface Profile {
    azureAdUserDetails: AzureAdUserDetails;
    affiliations: string[] | null;
    homeOrganisationId: string | null;
    businessPhone: string | null;
    mobilePhone: string | null;
    personalInformation: PersonalInformation | null;
    birthDate: string | null;
    tags: Tag[] | null;
    liabilities: Liability[] | null;
    eciuEmailAddress: string | null;
    recoveryEmailAddress: string | null;
    recoveryEmailVerifiedDate: string | null;
    motivationScanResult: MotivationScanResult | null;
    doNotBulkEmails: boolean | null;
    isCorporateTrainingManager: boolean;
    hasOpenSupportCases: boolean;
    canMakeIntegrationRequest: KeyValuePairOfBooleanAndString;
}

export interface AzureAdUserDetails {
    id: string;
    userName: string | null;
    givenName: string | null;
    surName: string | null;
}

export interface PersonalInformation {
    firstName: KeyValuePairOfBooleanAndString;
    lastName: KeyValuePairOfBooleanAndString;
    birthDate: KeyValuePairOfBooleanAndNullableDateTime;
    citizenship: KeyValuePairOfBooleanAndNullableGuid;
    nationality: KeyValuePairOfBooleanAndNullableGuid;
    language: KeyValuePairOfBooleanAndNullableGuid;
    genderId: KeyValuePairOfBooleanAndNullableInteger;
    currentStudyDegreeId: KeyValuePairOfBooleanAndNullableGuid;
    currentStudyDegreeVerifiedDate: KeyValuePairOfBooleanAndNullableDateOnly;
    highestCompletedUniversityDegreeId: KeyValuePairOfBooleanAndNullableGuid;
    highestCompletedUniversityDegreeVerifiedDate: KeyValuePairOfBooleanAndNullableDateOnly;
    graduationDate: KeyValuePairOfBooleanAndNullableDateOnly;
    streetAddress: KeyValuePairOfBooleanAndString;
    city: KeyValuePairOfBooleanAndString;
    stateProvinceRegion: KeyValuePairOfBooleanAndString;
    zipPostalCode: KeyValuePairOfBooleanAndString;
    country: KeyValuePairOfBooleanAndString;
    phone: KeyValuePairOfBooleanAndString;
    businessLanguage: KeyValuePairOfBooleanAndString;
    organisation: KeyValuePairOfBooleanAndString;
    highestLevelOfStudy: KeyValuePairOfBooleanAndString;
    yearAquired: KeyValuePairOfBooleanAndNullableInteger;
    studyProgramme: KeyValuePairOfBooleanAndString;
    homeUniversity: KeyValuePairOfBooleanAndString;
    linkedInUrl: KeyValuePairOfBooleanAndString;
}

export interface KeyValuePairOfBooleanAndString {
    key: boolean;
    value: string | null;
}

export interface KeyValuePairOfBooleanAndNullableDateTime {
    key: boolean;
    value: string | null;
}

export interface KeyValuePairOfBooleanAndNullableGuid {
    key: boolean;
    value: string | null;
}

export interface KeyValuePairOfBooleanAndNullableInteger {
    key: boolean;
    value: number | null;
}

export interface KeyValuePairOfBooleanAndNullableDateOnly {
    key: boolean;
    value: string | null;
}

export interface MotivationScanResult {
    answers: MotivationScanResultAnswer[];
}

export interface MotivationScanResultAnswer {
    competenceId: string;
    like: boolean;
}

export interface UpdatePassword {
    currentPassword: string;
    newPassword: string;
}

export interface UpdateMotivationScanResult {
    answers: MotivationScanResultAnswer[];
}

export interface UpdatePersonalDetails {
    citizenship: string | null;
    nationality: string | null;
    dateOfBirth: string | null;
    genderId: number | null;
    nativeLanguage: string | null;
    currentStudyDegree: string | null;
    highestCompletedUniversityDegree: string | null;
}

export interface UpdateContactInformation {
    firstName: string | null;
    lastName: string | null;
    streetAddress: string | null;
    city: string | null;
    stateProvinceRegion: string | null;
    zipPostalCode: string | null;
    country: string | null;
    phoneNumber: string | null;
}

export interface UpdateWorkAndStudy {
    businessLanguage: string | null;
    organisation: string | null;
    highestLevelOfStudy: string | null;
    yearAquired: number | null;
    studyProgramme: string | null;
    homeUniversity: string | null;
    linkedInUrl: string | null;
}

export interface CompetencePassport {
    topics: CompetencePassportTopic[];
}

export interface CompetencePassportTopic {
    id: string;
    name: string | null;
    competencePassportSubTopicWithNoOfCompletedLearningOpportunitiesByLevel: CompetencePassportSubTopicWithNoOfCompletedLearningOpportunitiesByLevel[];
}

export interface CompetencePassportSubTopicWithNoOfCompletedLearningOpportunitiesByLevel {
    id: string;
    name: string | null;
    noOfCompletedLearningOpportunitiesExplorer: number;
    noOfCompletedLearningOpportunitiesExpert: number;
    noOfCompletedLearningOpportunitiesPioneer: number;
}

export interface LearnerSkill {
    id: string;
    skillId: string | null;
    skillDescription: string | null;
    skillName: string | null;
    taxonomyId: string | null;
    taxonomyName: string | null;
    learnerId: string | null;
    level: Level | null;
    statusReason: LearnerSkillStatusReason | null;
    motivatedToDevelop: boolean;
}

export enum LearnerSkillStatusReason {
    Claimed = 1,
    Inactive = 2,
    Calculated = 623140001,
    Obtained = 623140002,
    Verified = 623140003,
    Goal = 623140004,
}

export interface UpdateSkillGoal {
    skillId: string;
    level: Level;
    reason: LearnerSkillStatusReason;
    motivatedToDevelop: boolean;
}

export interface CreateAuthenticatedSupportRequest {
    contactFormSettingId: string;
    request: string;
    learningOpportunityId: string | null;
}

export interface CreateUnAuthenticatedSupportRequest extends CreateAuthenticatedSupportRequest {
    userFullName: string;
    userHomeUniversityId: string | null;
    userEmailAddress: string;
}

export interface ContactFormSetting {
    id: string;
    name: string | null;
    sortOrder: number | null;
    additionalFields: string[] | null;
    subjectTitle: string | null;
}

export interface KeyValuePairOfGuidAndString {
    key: string;
    value: string | null;
}

export interface KeyValuePairOfIntegerAndString {
    key: number;
    value: string;
}

export interface Audience2 {
    id: string | null;
    name: string | null;
    description: string | null;
    url: string | null;
    hideFromFilter: boolean | null;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new SwaggerException(message, status, response, headers, result);
}

/**
 * Extends generated nswag clients with multi-part form capability.
 * This file is imported by the generator.
 */
/* eslint-disable @typescript-eslint/no-var-requires */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FormData = require("form-data");
/* eslint-enable @typescript-eslint/no-var-requires */

export {}; // to consider the file a module. Resolves build issue.